import { readAuthConfig } from './authConfig'

/**
 * Land on the branded in-app login. Email-first sign-in now renders at `/`
 * (src/screens/Login.tsx) with NO hosted-UI redirect — the browser never
 * navigates to *.amazoncognito.com. This shim keeps its signature for API
 * stability: the legacy call sites (ClaimLanding/GetReady/Tickets/Orders) just
 * need to reach `/`, where the unauthed app renders Login. Resolves true when a
 * consumer pool is configured, false when the build has no pool values.
 *
 * @param opts.signup Advisory only now (the email-first flow decides create vs
 *   sign-in from the email itself); retained for call-site API stability.
 */
export async function startSignIn(opts: { signup?: boolean } = {}): Promise<boolean> {
  void opts.signup
  const config = readAuthConfig()
  window.location.assign('/')
  return config !== null
}
